export default "/_next/static/images/top-texture-03a9aa675b1799dcfa099e20123c151d.svg";